/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetDetailReference,
    AIDatasetDetailReferenceFromJSON,
    AIDatasetDetailReferenceFromJSONTyped,
    AIDatasetDetailReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AICategoryDetailPartialUpdate
 */
export interface AICategoryDetailPartialUpdate {
    /**
     * 
     * @type {AIDatasetDetailReference}
     * @memberof AICategoryDetailPartialUpdate
     */
    dataset?: AIDatasetDetailReference;
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetailPartialUpdate
     */
    name?: string;
}

export function AICategoryDetailPartialUpdateFromJSON(json: any): AICategoryDetailPartialUpdate {
    return AICategoryDetailPartialUpdateFromJSONTyped(json, false);
}

export function AICategoryDetailPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AICategoryDetailPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataset': !exists(json, 'dataset') ? undefined : AIDatasetDetailReferenceFromJSON(json['dataset']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AICategoryDetailPartialUpdateToJSON(value?: AICategoryDetailPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataset': AIDatasetDetailReferenceToJSON(value.dataset),
        'name': value.name,
    };
}


